import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    theme: {
      validations: []
    },
    category: {
      validations: []
    },
    notes: {
      validations: []
    },
    reference: {
        validations: []
      },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ] 
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'TelNumber'
          }
        ]
      },
      {
    fields: [
      {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Type of Event:',
        options: [
          { label: 'Corporate' , value: 'Corporate'},
          { label: 'Holiday' , value: 'Holiday'},
          { label: 'Private' , value: 'Private'},
          { label: 'Wedding' , value: 'Wedding'},
        ],
        mapping: 'theme'
      }
    ]
  },
  {
    fields: [
      {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Season of Event:',
        options: [
          { label: 'Spring' , value: 'Spring'},
          { label: 'Summer' , value: 'Summer'},
          { label: 'Fall' , value: 'Fall'},
          { label: 'Winter' , value: 'Winter'},
        ],
        mapping: 'category'
      }
    ]
  },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Information:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Where did you hear of us?:',
            options: [
              { label: 'Search Engine' , value: 'Search Engine'},
              { label: 'Word of Mouth' , value: 'Word of Mouth'},
              { label: 'Social Media' , value: 'Social Media'},
              { label: 'Been to the Park Tavern Restaurant' , value: 'Been to the Park Tavern Restaurant'},
              { label: 'Email' , value: 'Email'},
              { label: 'The Knot' , value: 'The Knot'},
              { label: 'Jezebel' , value: 'Jezebel'},
              { label: 'Other' , value: 'Other'},
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Park Tavern and Piedmont Room Contact Form',
    formId: '2150',
    clientKey: '6BF1FA72-5AF3-411D-B3A5-0937C7975189',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText:'',
    redirectUrl: 'https://www.piedmontroom.com/thank-you/',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
